import React from 'react';

import LottieView from 'lottie-react-native';

import animation from './look.json';

export const LookAnimation = () => (
  <LottieView
    source={animation}
    style={{ width: 100, height: 130, marginTop: -15 }}
    autoPlay
    loop
  />
);
